import { useMutation, useQueryClient } from '@tanstack/react-query'
import { client } from '../../services/client'
import { useToast } from '../../contexts/toastContext'
import { clientImportQueryKeys } from './queries'

async function clearClientLoyaltyPoints({ objectId }: { objectId: string }) {
  const response = await client
    .post('functions/cleanClientImportLoyaltyPoints', {
      json: { objectId },
    })
    .json()

  return response
}

function useCleanClientImportLoyaltyPoints() {
  const setToast = useToast()
  const queryClient = useQueryClient()

  return useMutation(clearClientLoyaltyPoints, {
    onError: (error) => {
      const errorMsg = error instanceof Error ? error.message : 'Unknown error.'

      setToast({
        message: `Something went wrong while updating: ${errorMsg}`,
        color: 'danger',
      })
    },
    onSettled: () =>
      queryClient.invalidateQueries({ queryKey: clientImportQueryKeys.all }),
  })
}

export { useCleanClientImportLoyaltyPoints }
